




import { Vue, Component } from 'vue-property-decorator';

@Component
export default class Reject080 extends Vue {}
